<!-- <div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <p>Audit Filters:</p>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>
</div> -->
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <mat-toolbar class="top_headerbar">
    <div class="right">
      <div class="all_action_btns">
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by User Name"
            [(ngModel)]="clientName"
            (input)="searchbyname($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Site Name"
            [(ngModel)]="site"
            (input)="searchbySite($event.target.value)"
          />
        </div>

        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Application"
            [(ngModel)]="application"
            (input)="searchbyApplication($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by serial number"
            [(ngModel)]="sNumber"
            (input)="searchbySerialNo($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by mac address"
            [(ngModel)]="macAdd"
            (input)="searchData($event.target.value)"
          />
        </div>

        <div>
          <mat-form-field>
            <div class="label">
              <mat-label></mat-label>
            </div>
            <div class="inside">
              <mat-date-range-input [rangePicker]="picker">
                <input
                  matStartDate
                  [formControl]="range.controls['start']"
                  placeholder="Start date"
                />
                <input
                  matEndDate
                  [formControl]="range.controls['end']"
                  placeholder="End date"
                />
              </mat-date-range-input>
            </div>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            class="custom_button"
            (click)="onDateRangeChange(range.value.start, range.value.end)"
            [disabled]="!range.value.start && !range.value.end"
          >
            Apply Date Range
          </button>

          <button
            mat-raised-button
            color="warn"
            class="custom_button active_clear"
            (click)="clearFilters()"
            [disabled]="
              !(
                clientName != '' ||
                site != '' ||
                application != '' ||
                sNumber != '' ||
                macAdd != '' ||
                range.value.start != null ||
                range.value.end != null
              )
            "
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <div class="asset_list_view_outer" id="table-to-print">
    <div class="list_view_outer">
      <div class="table-responsive">
        <table class="table table-hover" *ngIf="showEmptyError == ''">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Site Name</th>
              <th>Application Name</th>
              <th>Serial Number</th>
              <th>Mac Address</th>
              <th>Module</th>
              <th>Created Date / Time</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let report of paginatedReportDataArr; let idx = index">
              <!-- <tr *ngFor="let report of reportDataArr| searchfilter: searchText;let idx = index; "> -->
              <td>{{ report?.client || "N/A" }}</td>
              <td>{{ report?.site || "N/A" }}</td>
              <td class="txt-color">{{ report?.application || "N/A" }}</td>
              <td>{{ report?.serial_number || "N/A" }}</td>
              <td>{{ report?.mac_address || "N/A" }}</td>
              <td>{{ report?.module || "N/A" }}</td>
              <td>{{ report?.created_at || "N/A" }}</td>

              <td class="text-right">
                <button
                  class="no-print"
                  mat-raised-button
                  color="primary"
                  (click)="viewAuditReport(report.updated_obj)"
                >
                  <span>View Changes</span>
                </button>
              </td>
            </tr>
            <!-- This is the hidden detail row that will be toggled before printing -->

            <div *ngIf="selectedReportDetails" class="report-details">
              <h3>Report Details:</h3>
              <p>User Name: {{ selectedReportDetails.client }}</p>
              <p>Site Name: {{ selectedReportDetails.site }}</p>
              <!-- add more details as needed -->
            </div>
          </tbody>
        </table>
      </div>
      <div
        *ngIf="
          showEmptyError !== '' ||
          (reportDataArr?.length === 0 && filtersApplied)
        "
        class="no_result"
      >
        <p
          style="
            font-size: 16px;
            color: #838383;
            text-align: center;
            padding: 30px;
          "
        >
          {{
            showEmptyError || "No records available for this filter criteria"
          }}
        </p>
      </div>
    </div>
  </div>

  <!-- Add a message when no records are available -->
  <div *ngIf="reportDataArr?.length === 0 && !filtersApplied" class="no_result">
    <p>No records available.</p>
  </div>

  <div class="button-container">
    <button
      mat-raised-button
      color="primary"
      (click)="viewAuditReports()"
      [disabled]="
        reportDataArr?.length === 0 || (showEmptyError !== '' && filtersApplied)
      "
    >
      Print / Save as PDF
    </button>
  </div>

  <div *ngIf="showEmptyError === ''" class="d-flex justify-content-center">
    <mat-paginator
      [length]="reportDataArr.length"
      [pageSize]="itemsPerPage"
      [pageSizeOptions]="[5, 10, 20, 50]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
